import { combineReducers } from 'redux'

import clients from './clients'
import filter from './filter'

export const rootReducer = combineReducers({
  clients,
  filter
})
